var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuteOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/mute_off"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.5 8.031A5.977 5.977 0 0 1 19 12a5.977 5.977 0 0 1-1.5 3.969M19.708 6A8.967 8.967 0 0 1 22 12a8.967 8.967 0 0 1-2.292 6M4 7.904H2.333C1.597 7.904 1 8.474 1 9.178v5.644c0 .704.597 1.274 1.333 1.274H4m0-8.192v8.192m0-8.192 4.72-4.758C10.022 2.11 12 2.994 12 4.614v14.772c0 1.62-1.978 2.505-3.28 1.468L4 16.096m8-7.918v7.644c2.21 0 4-1.711 4-3.822 0-2.11-1.79-3.822-4-3.822Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteOff);
export default __webpack_public_path__ + "static/media/mute_off.a174cb34f91abe291ad08acd8b1d0989.svg";
export { ForwardRef as ReactComponent };